import React from 'react';
import { StyledGhostProduct } from './styles';
import { AutoTextSize } from 'utils/autoTextSizeUtils';

export type IGhostProductProps = {
  productImage: string;
  quantityDisplay: string;
  textColor: string;
  suffix?: string;
};

export const GhostProduct: React.FC<IGhostProductProps> = ({
  productImage,
  quantityDisplay,
  textColor,
  suffix = '',
}) => {
  return (
    <StyledGhostProduct textColor={textColor} suffix={suffix}>
      <div className="image-container">
        <img src={productImage} alt="product" className="image" />
      </div>
      <AutoTextSize
        as="span"
        maxFontSizePx={16}
        minFontSizePx={4}
        mode="oneline"
        className="quantity"
      >
        {quantityDisplay}
      </AutoTextSize>
    </StyledGhostProduct>
  );
};
